import { createStyles, Switch, Theme, withStyles } from "@material-ui/core";
import * as React from "react";

export const DropOffTemplateSwitch = withStyles(
  (theme: Theme) =>
    createStyles({
      checked: {},
      focusVisible: {},
      root: {
        height: 35,
        margin: "0 0 0 5px",
        padding: 0,
        width: 60
      },
      switchBase: {
        "&$checked": {
          "& + $track": {
            backgroundColor: "transparent",
            border: "none",
            opacity: 1
          },
          color: "#0630ff",
          transform: "translateX(16px)"
        },
        "&$focusVisible $thumb": {
          border: "6px solid #0630ff",
          color: "#0630ff"
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          backgroundColor: theme.palette.grey[50]
        },
        color: "#0030ff",
        left: "-3px",
        padding: 1,
        top: "1px"
      },
      thumb: {
        height: 26,
        width: 26
      },
      track: {
        backgroundColor: theme.palette.grey[50],
        border: `1px solid #C5C5C5`,
        borderRadius: "17px",
        height: "30px",
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
        width: "52px"
      }
    }),
  { name: "DropOffTemplateSwitch" }
)(({ classes, ...props }: any) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disabled={props.disabled}
    disableRipple
    classes={{
      checked: classes.checked,
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track
    }}
    {...props}
  />
));
